import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { msalInstance } from "../../Api";
import { MENU, SEARCH } from "../../Constants";
import SignalrHelper from "../../Helpers/signalr";
import { OutotecIcons } from "../General/Icons";
import FeedbackModal from "../General/Modal/FeedbackModal";
import { headerFix } from "../../Helpers/layout";
import { userStore } from "../../Store/userStore";
import salesInfoStore from "../../Store/SalesInfoStore";
import useSearchStore from "../../Store/search";

function getDownloads(exportFiles) {
    return Object.keys(exportFiles)
        .map((key) => exportFiles[key])
        .filter((x) => x.visible);
}

interface HeaderProps {
    yammerUri: string;
    onToggleMobileMenu: () => any;
    onToggleMobileSearch: () => any;
}
export default function Header(props: HeaderProps) {
    const isAdminUser = userStore((s) => s.user?.isAdminUser);
    const toggleAdminMenu = salesInfoStore((s) => s.toggleAdminMenu);
    const exportFiles = useSearchStore((s) => s.exportFiles);
    const toggleDownloadsMenu = useSearchStore((s) => s.toggleDownloadsMenu);
    const [feedbackModalOpen, setFeedbackModalOpen] = useState<Boolean>(false);

    useEffect(() => {
        headerFix();
        const signalRHelper = new SignalrHelper();

        signalRHelper.init(() => {
            signalRHelper.listenForFileExportEvents();
        });
    }, []);

    const toggleFeedbackModal = () => {
        setFeedbackModalOpen(!feedbackModalOpen);
    };

    return (
        <div className="Header">
            <div className="container-fluid">
                <div className="Header__container">
                    <div className="Header__brand">
                        <Link to={{ pathname: "/" }}>
                            Browse change requests
                            <img
                                className="Header__logo"
                                src="/metso_logo_black.png"
                            />
                        </Link>
                        <div
                            className="Header__mobileMenu"
                            onClick={() => props.onToggleMobileMenu()}
                        >
                            <OutotecIcons type={MENU} />
                        </div>
                        <span className="Header__brandName">
                            Installed Base
                        </span>
                    </div>

                    <div className="Header__actions">
                        {getDownloads(exportFiles).length > 0 && (
                            <button
                                onClick={() => toggleDownloadsMenu(true)}
                                className="btn btn-primary Header__downloadMenuButton"
                            >
                                Exports
                            </button>
                        )}
                        {isAdminUser && (
                            <button
                                onClick={() => toggleAdminMenu(true)}
                                className="btn btn-primary Header__adminMenuButton"
                            >
                                Admin menu
                            </button>
                        )}

                        <button
                            className="btn btn-secondary me-3"
                            onClick={toggleFeedbackModal}
                        >
                            Feedback
                        </button>

                        {feedbackModalOpen && (
                            <FeedbackModal onClose={toggleFeedbackModal} />
                        )}

                        <button
                            type="submit"
                            className="btn btn-secondary me-3"
                            onClick={() => window.open(props.yammerUri)}
                        >
                            Yammer
                        </button>

                        <a
                            className="Header__logout"
                            href="#"
                            onClick={() =>
                                msalInstance.logoutRedirect({
                                    postLogoutRedirectUri: "/",
                                })
                            }
                        >
                            Log out
                        </a>
                    </div>
                    <div
                        className="Header__mobileSearch"
                        onClick={() => props.onToggleMobileSearch()}
                    >
                        <OutotecIcons type={SEARCH} />
                    </div>
                </div>
            </div>
        </div>
    );
}
